import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { IpcChannel, IpcV2Service } from './ipc-v2.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  user:any;
  public userObs = new BehaviorSubject(null);
  userSub = this.userObs.asObservable();

  constructor(private router:Router, private ipcV2: IpcV2Service) {
      let temp = JSON.parse(localStorage.getItem('user') || '{}');
      this.user = temp;
  }

  isAuthenticated(): boolean {
    return this.user && this.user.token && (+new Date(this.user.tokenExpriy)) > Date.now();
  }

  saveUser(user: any) {
    this.user = user;
    this.userObs.next(user);
    localStorage.removeItem('user');
    localStorage.setItem('user', JSON.stringify(user));
    this.ipcV2.sendAndReceive(IpcChannel.SAVE_USER, JSON.stringify(user)).subscribe();
  }

  getUser(): any {
    return this.user;
  }

  getUserId(): any {
    if(this.user) {
      return this.user.id;
    }
    return null;
  }

  getToken(): string {
    if(this.user) {
      return this.user.token;
    }
    return '';
  }

  logout() {
    this.user = null;
    localStorage.removeItem('user');
    this.router.navigate(['/login']);
  }

  isAdmin(): boolean {
    if(this.user) {
      return this.user.role === 'admin';
    }
    return false;
  }

  checkTokenExpires(): boolean {
    if(this.user) {
      return this.user.tokenExpriy > Date.now();
    }
    return false;
  }

}
